export const Types = {
  RESET_DATA: "cattleProducer/RESET_DATA",
  GET_ALL_CATTLE_PRODUCERS: "cattleProducer/GET_ALL_CATTLE_PRODUCERS",
  GET_ALL_CATTLE_PRODUCERS_SUCCESS:
    "cattleProducer/GET_ALL_CATTLE_PRODUCERS_SUCCESS",
  GET_ALL_CATTLE_PRODUCERS_ERROR:
    "cattleProducer/GET_ALL_CATTLE_PRODUCERS_ERROR",
  GET_CATTLE_PRODUCER: "cattleProducer/GET_CATTLE_PRODUCER",
  GET_CATTLE_PRODUCER_SUCCESS: "cattleProducer/GET_CATTLE_PRODUCER_SUCCESS",
  GET_CATTLE_PRODUCER_ERROR: "cattleProducer/GET_CATTLE_PRODUCER_ERROR",
  SHOW_DRAWER_CATTLE_PRODUCER: "cattleProducer/SHOW_DRAWER_CATTLE_PRODUCER",
  HIDE_DRAWER_CATTLE_PRODUCER: "cattleProducer/HIDE_DRAWER_CATTLE_PRODUCER",
  SAVE_CATTLE_PRODUCER: "cattleProducer/SAVE_CATTLE_PRODUCER",
  SAVE_CATTLE_PRODUCER_SUCCESS: "cattleProducer/SAVE_CATTLE_PRODUCER_SUCCESS",
  SAVE_CATTLE_PRODUCER_ERROR: "cattleProducer/SAVE_CATTLE_PRODUCER_ERROR",
  DELETE_CATTLE_PRODUCER: "cattleProducer/DELETE_CATTLE_PRODUCER",
  DELETE_CATTLE_PRODUCER_SUCCESS:
    "cattleProducer/DELETE_CATTLE_PRODUCER_SUCCESS",
  DELETE_CATTLE_PRODUCER_ERROR: "cattleProducer/DELETE_CATTLE_PRODUCER_ERROR",
  GET_DROPDOWN_CATTLE_PRODUCERS: "cattleProducer/GET_DROPDOWN_CATTLE_PRODUCERS",
  GET_DROPDOWN_CATTLE_PRODUCERS_SUCCESS:
    "cattleProducer/GET_DROPDOWN_CATTLE_PRODUCERS_SUCCESS",
  GET_DROPDOWN_CATTLE_PRODUCERS_ERROR:
    "cattleProducer/GET_DROPDOWN_CATTLE_PRODUCERS_ERROR",
};

export const Creators = {
  indexCattleProducers: (
    groupId,
    farmId,
    page = 0,
    sorter = null,
    filters = null,
    size = 10
  ) => ({
    type: Types.GET_ALL_CATTLE_PRODUCERS,
    payload: {
      groupId,
      farmId,
      page,
      sorter,
      filters,
      size,
    },
  }),

  indexCattleProducersSuccess: (data) => ({
    type: Types.GET_ALL_CATTLE_PRODUCERS_SUCCESS,
    payload: {
      data,
    },
  }),

  indexCattleProducersError: (error) => ({
    type: Types.GET_ALL_CATTLE_PRODUCERS_ERROR,
    payload: {
      error,
    },
  }),

  showCattleProducer: (groupId, farmId, id) => ({
    type: Types.GET_CATTLE_PRODUCER,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),

  showCattleProducerSuccess: (data) => ({
    type: Types.GET_CATTLE_PRODUCER_SUCCESS,
    payload: {
      data,
    },
  }),

  showCattleProducerError: (error) => ({
    type: Types.GET_CATTLE_PRODUCER_ERROR,
    payload: {
      error,
    },
  }),

  showDrawer: (actionType = "edit", id = null) => ({
    type: Types.SHOW_DRAWER_CATTLE_PRODUCER,
    payload: {
      actionType,
      id,
    },
  }),

  hideDrawer: () => ({
    type: Types.HIDE_DRAWER_CATTLE_PRODUCER,
    payload: {},
  }),

  saveCattleProducer: (groupId, farmId, id = null, cattleProducer) => ({
    type: Types.SAVE_CATTLE_PRODUCER,
    payload: {
      groupId,
      farmId,
      id,
      cattleProducer,
    },
  }),

  saveCattleProducerSuccess: (data) => ({
    type: Types.SAVE_CATTLE_PRODUCER_SUCCESS,
    payload: { data },
  }),

  saveCattleProducerError: (error) => ({
    type: Types.SAVE_CATTLE_PRODUCER_ERROR,
    payload: { error },
  }),

  deleteCattleProducer: (groupId, farmId, id) => ({
    type: Types.DELETE_CATTLE_PRODUCER,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),

  deleteCattleProducerSuccess: () => ({
    type: Types.DELETE_CATTLE_PRODUCER_SUCCESS,
    payload: {},
  }),

  deleteCattleProducerError: (error) => ({
    type: Types.DELETE_CATTLE_PRODUCER_ERROR,
    payload: { error },
  }),

  getDropdownCattleProducers: (groupId, farmId) => ({
    type: Types.GET_DROPDOWN_CATTLE_PRODUCERS,
    payload: {
      groupId,
      farmId,
    },
  }),

  getDropdownCattleProducersSuccess: (data) => ({
    type: Types.GET_DROPDOWN_CATTLE_PRODUCERS_SUCCESS,
    payload: {
      data,
    },
  }),

  getDropdownCattleProducersError: (error) => ({
    type: Types.GET_DROPDOWN_CATTLE_PRODUCERS_ERROR,
    payload: {
      error,
    },
  }),
};

const INITIAL_STATE = {
  data: null,
  listDrowpDown: [],
  pagination: {
    page: 0,
    sorter: null,
    filters: null,
    size: 10,
    tableFilters: null,
  },
  isLoading: false,
  isLoadingDropDown: false,
  isCattleProducerListDrowpDownLoading: false,
  isLoadingRequest: false,
  error: [],
  cattleProducerData: null,
  idCattleProducerEdit: null,
  drawerVisible: false,
  drawerActionType: null,
};

export default function cattleProducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.GET_ALL_CATTLE_PRODUCERS:
      const { page, sorter, filters, size } = action.payload;
      return {
        ...state,
        pagination: {
          page,
          sorter,
          filters,
          size,
          tableFilters: filters,
        },
        isLoading: true,
      };
    case Types.GET_ALL_CATTLE_PRODUCERS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload.data };
    case Types.GET_ALL_CATTLE_PRODUCERS_ERROR:
      const { error } = action.payload;
      return { ...state, isLoading: false, data: null, error };
    case Types.GET_CATTLE_PRODUCER:
      return { ...state, isLoadingRequest: true };
    case Types.GET_CATTLE_PRODUCER_SUCCESS:
      return {
        ...state,
        isLoadingRequest: false,
        cattleProducerData: action.payload.data,
      };
    case Types.GET_CATTLE_PRODUCER_ERROR:
      return {
        ...state,
        isLoadingRequest: false,
        cattleProducerData: null,
        error: action.payload.error,
      };
    case Types.SHOW_DRAWER_CATTLE_PRODUCER:
      return {
        ...state,
        drawerActionType: action.payload.actionType,
        drawerVisible:
          action.payload.actionType === "edit" ||
          action.payload.actionType === "new"
            ? true
            : false,
        idCattleProducerEdit: action.payload.id,
      };
    case Types.HIDE_DRAWER_CATTLE_PRODUCER:
      return {
        ...state,
        drawerVisible: false,
        cattleProducerData: null,
        idCattleProducerEdit: null,
      };
    case Types.SAVE_CATTLE_PRODUCER:
      return { ...state, isLoadingRequest: true };
    case Types.SAVE_CATTLE_PRODUCER_SUCCESS:
      return {
        ...state,
        isLoadingRequest: false,
        cattleProducerData: null,
        drawerVisible: false,
        drawerActionType: null,
      };
    case Types.SAVE_CATTLE_PRODUCER_ERROR:
      return {
        ...state,
        isLoadingRequest: false,
        error: action.payload.error,
      };
    case Types.DELETE_CATTLE_PRODUCER:
      return { ...state, isLoading: true };
    case Types.DELETE_CATTLE_PRODUCER_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Types.DELETE_CATTLE_PRODUCER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.GET_DROPDOWN_CATTLE_PRODUCERS:
      return {
        ...state,
        isLoadingDropDown: true,
        isCattleProducerListDrowpDownLoading: true,
      };
    case Types.GET_DROPDOWN_CATTLE_PRODUCERS_SUCCESS:
      return {
        ...state,
        isLoadingDropDown: false,
        isCattleProducerListDrowpDownLoading: false,
        listDrowpDown: action.payload.data,
      };
    case Types.GET_DROPDOWN_CATTLE_PRODUCERS_ERROR:
      return {
        ...state,
        isLoadingDropDown: false,
        isCattleProducerListDrowpDownLoading: false,
        listDrowpDown: [],
        error: action.payload.error,
      };
    default:
      return state;
  }
}
